import { render, staticRenderFns } from "./KakaoPopup.vue?vue&type=template&id=279e2c04&scoped=true"
import script from "./KakaoPopup.vue?vue&type=script&lang=js"
export * from "./KakaoPopup.vue?vue&type=script&lang=js"
import style0 from "./KakaoPopup.vue?vue&type=style&index=0&id=279e2c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279e2c04",
  null
  
)

export default component.exports